import inboxService from '@/api/inbox.service'

const actions = {
  getChatGroupList: context => {
    return new Promise((resolve, reject) => {
      inboxService
        .getChatGroupList(context)
        .then(response => {
          // context.commit('messages', response);
          resolve(response)
        })
        .catch(err => reject(err))
    })
  },
  getChatHistory: (context, data) => {
    return new Promise((resolve, reject) => {
      inboxService
        .getChatHistory(context, data)
        .then(response => {
          context.commit('messages', response)
          resolve(response)
        })
        .catch(err => reject(err))
    })
  },
  seenChatFlag: (context, data) => {
    return new Promise((resolve, reject) => {
      inboxService
        .seenChatFlag(context, data)
        .then(response => {
          resolve(response)
        })
        .catch(err => reject(err))
    })
  },
  getCandidatesList: context => {
    return new Promise((resolve, reject) => {
      inboxService
        .getCandidatesList(context)
        .then(response => {
          resolve(response)
        })
        .catch(err => reject(err))
    })
  },
  getRecruitersList: context => {
    return new Promise((resolve, reject) => {
      inboxService
        .getRecruitersList(context)
        .then(response => {
          resolve(response)
        })
        .catch(err => reject(err))
    })
  },
  attachFile: (context, data) => {
    return new Promise((resolve, reject) => {
      inboxService
        .attachFile(context, data)
        .then(response => {
          resolve(response)
        })
        .catch(err => reject(err))
    })
  },
  deleteChatGroup: (context, data) => {
    return new Promise((resolve, reject) => {
      inboxService
        .deleteChatGroup(context, data)
        .then(response => {
          resolve(response)
        })
        .catch(err => reject(err))
    })
  }
}

export default actions
